import { render, staticRenderFns } from "./health-hacks-quiz.vue?vue&type=template&id=009bc31c&"
import script from "./health-hacks-quiz.vue?vue&type=script&lang=js&"
export * from "./health-hacks-quiz.vue?vue&type=script&lang=js&"
import style0 from "./health-hacks-quiz.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports